/**
 * Which iPhone build is this? Shown at the bottom of «Настройки» (D-71).
 * Taken from Book&Host 69d7046 web/src/core/version.ts: the installed app
 * reads its own Info.plist through @capacitor/app, so the number is what
 * Xcode shipped and cannot drift.
 *
 * Not taken: Book&Host's browser fallback baked in from project.pbxproj.
 * MasterDay shows the line in the iPhone app only, so a browser gets null.
 */
import { Capacitor } from '@capacitor/core';

/** 1.0 and 2 -> "1.0.2", Book&Host's format. */
export function formatVersion(version: string, build: string): string | null {
  if (!version) return null;
  return build ? `${version}.${build}` : version;
}

/**
 * The installed iPhone app's version, or null anywhere else. Never throws: a
 * missing or failing plugin hides the line rather than showing a wrong one.
 */
export async function resolveAppVersion(): Promise<string | null> {
  if (Capacitor.getPlatform() !== 'ios') return null;
  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    return formatVersion(info.version ?? '', info.build ?? '');
  } catch {
    return null;
  }
}
